<template>
    <v-row class="ma-0 pb-offset">
        <v-col class="pa-0">
            <v-card elevation="1" class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Notifiche</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-container class="pa-0" fluid>
                    <v-row class="pa-4">
                        <v-list two-line subheader class="background-2 pa-2">
                            <v-list-item>
                                <v-list-item-action>
                                    <v-checkbox
                                        color="primary"
                                        hide-details
                                        v-model="settings['notification_disable_auto_read']"
                                    ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Disattiva lettura automatica notifiche</v-list-item-title>
                                    <v-list-item-subtitle>Le notifiche non verranno segnate come lette quando ci clicchi sopra</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions class="pr-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

    export default {
        name: 'profile-settings',
        mixins: [SettingsOptionsMixin],
        data() {
            return {
                model: 'viewing',
                settings: {
                    'notification_disable_auto_read': false,
                },
            }
        },
    }
</script>
